export function replaceChar(a){
    a = a.replace("*","")
    return a;
}